<script setup lang="ts">
const user = useFirebaseUser()
const isOpen = ref(false)
const isHidden = ref(true)

const header = ref<HTMLElement | undefined>()

function close() {
  if (!isHidden.value) {
    toggleOpen()
  }
}

function toggleOpen() {
  if (isHidden.value) {
    isHidden.value = false
    setTimeout(() => {
      visibleToggleOpen()
    }, 50)
  }
  else if (isOpen.value) {
    visibleToggleOpen()
    setTimeout(() => {
      isHidden.value = true
    }, 300)
  }
}

function visibleToggleOpen() {
  isOpen.value = !isOpen.value
  if (isOpen.value) {
    document.body.style.overflow = 'hidden'
  }
  else {
    document.body.style.overflow = ''
  }
}
</script>

<template>
  <header
    ref="header"
    :class="'sticky top-0 p-4 pb-0 md:p-0 md:m-0 z-50 transition-all ease-in duration-150 ' + (isOpen ? ' bg-white dark:bg-gray-800' : '')"
  >
    <div
      :class="'fixed top-0 bottom-0 left-0 right-0' + (isHidden ? ' hidden' : ' block')"
      @click="toggleOpen()"
    />
    <div
      :class="'can-scroll fixed ' + (isHidden ? ' hidden' : ' block') + ' top-4 md:top-6 md:top-0 left-0 right-0 bg-white dark:bg-gray-800 z-0 w-dvw h-dvh overflow-x-hidden overflow-y-auto transition-all ease-in duration-150 shadow-[0_8px_8px_-8px_rgba(0,0,0,0.3)]' + (isOpen ? ' translate-y-12 opacity-100' : ' -translate-y-5 opacity-0')"
    >
      <div class="p-4">
        <div
          v-if="user?.isAnonymous != false"
          class="p-3 max-w-[1200px] m-auto md:hidden"
        >
          <LayoutDefaultMyProfileAnonymous :toggle-open="toggleOpen" />
        </div>
        <div
          v-else
          class="p-3 max-w-[1200px] m-auto md:hidden"
        >
          <LayoutDefaultMyProfile :toggle-open="toggleOpen" />
        </div>
        <div class="p-3 pt-8 pb-16 max-w-[1200px] m-auto gap-12 flex flex-wrap lg:flex-nowrap">
          <div class="text-nowrap grow">
            <LayoutDefaultDiscover :toggle-open="toggleOpen" />
          </div>
          <div class="text-nowrap grow">
            <LayoutDefaultAroundTheMovement :toggle-open="toggleOpen" />
          </div>
          <div class="w-full grid grid-cols-1 pb-4">
            <LayoutDefaultFeaturedResources :toggle-open="toggleOpen" />
          </div>
        </div>
        <div
          v-if="user?.isAnonymous != false"
          class="p-3 pb-16 max-w-[1200px] m-auto hidden md:block"
        >
          <div class="max-w-[500px]">
            <LayoutDefaultMyProfileAnonymous :toggle-open="toggleOpen" />
          </div>
        </div>
        <div
          v-else
          class="p-3 pb-16 max-w-[1200px] m-auto hidden md:block"
        >
          <LayoutDefaultMyProfile :toggle-open="toggleOpen" />
        </div>
      </div>
    </div>
    <LayoutDefaultHeaderNav
      :is-open="isOpen"
      :toggle-open="toggleOpen"
      :close="close"
    />
  </header>
</template>
